import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('company_rebate_record')
}

const getters = {
  ...restful.getters('company_rebate_record')
}

const actions = {
  ...restful.actions('company_rebate_records')
}

const mutations = {
  ...restful.mutations('company_rebate_record')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
